// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"50948e0e","239":"bbc904fa","455":"2249d193"}[chunkId] + ".chunk.js";
};